// extracted by mini-css-extract-plugin
export default {"productDescription":"Z--z","featuredDescription":"_--z","description":"a_-z","more":"b_-z","descriptionSku":"c_-z"};